<template>
  <div>
    <div class="row ">
      <div class="col-12">
        <div class="cards card-custom">
          <div class="card-body d-flex flex-column pb-20">
            <div class="font-weight-bolder font-size-h3 mb-8">
              Paths of Contents
            </div>
            <div class="timeline timeline-3">
              <div class="timeline-items">
                <div
                  class="timeline-item"
                  v-for="(pt, index) in paths"
                  :key="pt._id"
                >
                  <div class="timeline-media">
                    <span
                      class="label label-xl  font-weight-bolder "
                      :style="
                        userChecked(index) ? 'background-color:#97daf8' : ''
                      "
                      >{{ paths.length - index }}</span
                    >
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-6">
                      <div class="timeline-content bg-white px-10 py-7">
                        <div
                          class="d-flex align-items-top justify-content-between"
                        >
                          <div class="mr-2">
                            <span class="text-muted ">{{
                              pt.startDate | moment("D MMM YYYY")
                            }}</span>
                            <h2
                              class="text-dark-75 text-hover-primary font-weight-bold mb-5"
                            >
                              {{ pt.title }}
                            </h2>

                            <div class="row mb-10" v-if="pt.tags">
                              <div v-for="t in pt.tags" :key="t._id">
                                <span
                                  class="label label-light-success font-weight-bolder label-inline ml-2"
                                  >{{ getTagInfo(t) }}</span
                                >
                              </div>
                              <span
                                class="label label-light-warning font-weight-bolder label-inline ml-2"
                                >{{ getLevelInfo(pt.level) }}</span
                              >
                            </div>
                          </div>
                          <div class="" :value="userChecked(index)">
                            <b-form-checkbox
                              switch
                              size="lg"
                              v-model="pt.isUserComplete"
                              @change="pathComplete(index)"
                            ></b-form-checkbox>
                          </div>
                        </div>
                        <div v-html="pt.description" class="mb-10"></div>
                        <div v-for="m in pt.material" :key="m._id" class="path">
                          <a
                            :href="getUrl(m)"
                            target="_blank"
                            class="non-decoration"
                          >
                            <h3 class="text-dark mt-3 mb-0 font-size-lg pl-4">
                              {{ m.name }}
                            </h3>
                          </a>

                          <div class="row d-flex align-items-center">
                            <a
                              :href="getUrl(m)"
                              target="_blank"
                              class="non-decoration"
                            >
                              <span
                                class="text-dark"
                                v-if="m.type === 'Classroom'"
                              >
                                <div
                                  class="symbol symbol-30 symbol-circle  mr-0 col-2 mb-0"
                                >
                                  <span class="symbol-label">
                                    <i
                                      class="fas fa-chalkboard-teacher text-danger"
                                    ></i>
                                  </span>
                                </div>
                              </span>

                              <span class="text-dark" v-if="m.type === 'Pdf'">
                                <div
                                  class="symbol symbol-30 symbol-circle mr-0 col-2 mb-0"
                                >
                                  <span class="symbol-label">
                                    <i class="fas fa-file-pdf text-danger"></i>
                                  </span>
                                </div>
                              </span>

                              <span class="text-dark" v-if="m.type === 'Video'">
                                <div class="symbol symbol-30 mr-0 col-2 mb-0">
                                  <span class="symbol-label">
                                    <i class="fas fa-video text-danger"></i>
                                  </span>
                                </div>
                              </span>

                              <span class="text-dark" v-if="m.type === 'Book'">
                                <div class="symbol symbol-30 mr-0 col-2 mb-0">
                                  <span class="symbol-label">
                                    <i class="fas fa-book text-danger"></i>
                                  </span>
                                </div>
                              </span>
                            </a>
                            <div>
                              <p
                                class="col-9 m-0 desc"
                                v-html="m.description"
                              ></p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-6" v-if="getChallenge(pt._id)">
                      <challenge-path
                        :path="pt"
                        :extended="isChallengVisible(pt)"
                      ></challenge-path>
                    </div>
                    <!-- <div class="col-12 col-md-6" v-if="getChallenge(pt._id)">
                      <b-card class="mb-5 card-custom" no-body>
                        <b-card-body>
                          <h6>Week challenge:</h6>
                          <div class="row align-items-center">
                            <div class="col-9">
                              <h3>{{ getChallenge(pt._id).title }}</h3>
                              <div
                                v-html="getChallenge(pt._id).description"
                              ></div>
                            </div>
                            <div class="col-3 text-right">
                              <router-link
                                :to="
                                  '/paths/challenge/' + getChallenge(pt._id)._id
                                "
                              >
                                <span class="points">
                                  <span
                                    v-for="p of getChallenge(pt._id).points"
                                    :key="p._id"
                                  >
                                    <span class="badge badge-light p-3 px-5">
                                      <IconProfile
                                        :profileId="p.profile"
                                      ></IconProfile>
                                      {{ p.points }}</span
                                    >
                                  </span>
                                </span>
                              </router-link>
                            </div>
                            
                        </b-card-body>
                      </b-card>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4">
            <div class="card card-custom">
              <div class="card-body d-flex flex-column"></div>
            </div>
          </div> -->
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import "@/core/plugins/collapse";
import { mapGetters } from "vuex";

import ChallengePath from "../layout/dashboard/ChallengePath.vue";

// var id;
// var idTeam;

export default {
  name: "all-paths",
  components: { ChallengePath },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
  },
  computed: {
    paths() {
      return this.$store.getters.getPaths.filter((p) => p.isActive === true);
    },
    sessions() {
      return this.$store.getters.getSessions;
    },
    projects() {
      return this.$store.getters.getProjects;
    },
    instances() {
      return this.$store.getters.getInstances;
    },
    levels() {
      return this.$store.getters.getLevels;
    },
    profiles() {
      return this.$store.getters.getProfiles;
    },
    tags() {
      return this.$store.getters.getTags;
    },
    challenges() {
      return this.$store.getters.getChallenges;
    },
    me() {
      return this.$store.getters.getMyUser;
    },
    //...mapGetters(["currentUser"]),

    activeProjects() {
      return this.me.instances.filter(
        (p) => !p.dateFinished & (p.cancelled === false)
      );
    },
    finishedProjects() {
      return this.me.instances.filter(
        (p) => p.dateFinished || p.cancelled == true
      );
    },
    ...mapGetters(["currentUser", "breadcrumbs", "pageTitle", "layoutConfig"]),
  },
  methods: {
    getUrl(material) {
      return material.type == "Pdf"
        ? process.env.VUE_APP_API_URL + material.url
        : material.url;
    },
    getChallenge(path) {
      return this.challenges.find((p) => path === p.path);
    },
    isChallengVisible(pt) {
      let startDate = new Date(pt.startDate);
      let startDate1 = new Date(pt.startDate);
      let today = new Date();
      if (
        (startDate1 > today && this.me.group == "B") ||
        (new Date(startDate1.setDate(startDate1.getDate() + 2)) > today &&
          this.me.group == "A")
      ) {
        return false;
      } else {
        console.log("ME", this.me);
        if (this.me.group == "B") {
          return (
            today.setDate(today.getDate()) <
            startDate.setDate(startDate.getDate() + 7)
          );
        } else {
          console.log(
            today.setDate(today.getDate()) <
              startDate.setDate(startDate.getDate() + 9)
          );
          return (
            today.setDate(today.getDate()) <
            startDate.setDate(startDate.getDate() + 9)
          );
        }
      }
    },
    getTagInfo(t) {
      let tag = this.tags.find((tag) => tag._id == t);
      return tag?.name;
    },
    getLevelInfo(l) {
      let level = this.levels.find((lev) => lev._id === l);
      return level?.name;
    },
    userChecked(i) {
      let complete = this.paths[i].users.find((p) => p == this.me._id);

      if (complete) {
        this.paths[i].isUserComplete = true;
      } else {
        this.paths[i].isUserComplete = false;
      }
      return this.paths[i].users.find((p) => p == this.me._id);
    },
    pathComplete(i) {
      console.log("change" + i);
      var complete = this.paths[i].users.find((p) => p == this.me._id);
      if (!complete) {
        this.paths[i].users.push(this.me._id);
      } else {
        let u = this.paths[i].users.indexOf(
          this.paths[i].users.find((p) => p == this.me._id)
        );
        this.paths[i].users.splice(u, 1);
      }
      axios
        .put("paths/" + this.paths[i]._id, { users: this.paths[i].users })
        .then((response) => {
          console.log(response);
        });
    },
  },
};
</script>

<style scoped lang="scss">
a.non-decoration {
  color: #3f4254;
}
.path {
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  margin-bottom: 5px;
  padding: 5px 6px 5px;
  background-color: rgba(255, 255, 255, 0.8);
}
.path .symbol {
  padding-left: 25px;
}
.path .symbol-label {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.timeline.timeline-3 .timeline-items .timeline-item .timeline-content:before {
  border-right-color: white;
}
.desc::v-deep {
  p {
    margin-bottom: 0;
  }
}
.points span {
  margin-right: 5px;
}

.points span i {
  margin-right: 4px;
  width: 20px;
}
</style>
